module.exports = __webpack_public_path__ + "img/snow-blowing.48782098.svg";